export default __webpack_public_path__ + "static/media/terms-document.414f3f20.svg";